import { render, staticRenderFns } from "./SharePopPc.vue?vue&type=template&id=099f797e&scoped=true&"
import script from "./SharePopPc.vue?vue&type=script&lang=js&"
export * from "./SharePopPc.vue?vue&type=script&lang=js&"
import style0 from "./SharePopPc.vue?vue&type=style&index=0&id=099f797e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099f797e",
  null
  
)

export default component.exports